/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";

(function preBootstrapSso() {
  try {
    if (typeof window === "undefined") return;
    const search = window.location?.search || "";
    if (!search || search.indexOf("token=") === -1) return;

    const params = new URLSearchParams(search);
    const token = (params.get("token") || "").trim();
    const applicationid = (params.get("applicationid") || "").trim();
    const bin = (params.get("bin") || "").trim();
    if (!token) return;

    // Decode JWT payload (best-effort; SignUpComponent.handleSsoIfPresent will
    // do its own decode too if this is skipped).
    let payload: any = {};
    try {
      const parts = token.split(".");
      if (parts.length === 3) {
        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""),
        );
        payload = JSON.parse(json) || {};
      }
    } catch {
      /* ignore */
    }

    const userId = String(
      payload.userId ||
        payload.userid ||
        payload.id ||
        applicationid ||
        bin ||
        "",
    ).trim();
    if (!userId) return;

    try {
      sessionStorage.setItem(
        "_pendingSso",
        JSON.stringify({
          token,
          applicationid,
          bin,
          userId,
          payload,
        }),
      );
    } catch {
      /* ignore */
    }

    // Rewrite the URL so Angular's first navigation lands on the target route.
    const targetRoute = bin
      ? `/dashboard/bin/${encodeURIComponent(bin)}`
      : "/dashboard";
    try {
      window.history.replaceState({}, "", targetRoute);
    } catch {
      /* ignore */
    }
  } catch (e) {
    console.warn("[SSO pre-bootstrap] failed", e);
  }
})();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

if (environment?.ENV_NAME === "Production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}
